import { StickyParameters as StickyParametersImplementation } from '@gebruederheitz/sticky-parameters';
import whenDomReady from 'when-dom-ready';

interface StickyParametersInstance {
    run(): void;
}

type StickyParametersConstructor = new (
    params: string[],
    externalDomains: string[],
    applyToExternalLinks: boolean
) => StickyParametersInstance;

const StickyParameters =
    StickyParametersImplementation as StickyParametersConstructor;

void whenDomReady(() => {
    new StickyParameters(
        [
            // UTM campaign parameters
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_term',
            'utm_content',
            // Google Ads click identifiers — kept sticky across internal
            // navigation so the checkout can read them at submit time for
            // offline conversion import. gclid is the standard click id;
            // wbraid/gbraid are the cookieless iOS / privacy-safe variants.
            // applyToExternalLinks stays false (third arg), so these are
            // only written into same-site links and never leak to third
            // parties.
            'gclid',
            'wbraid',
            'gbraid',
        ],
        [],
        false
    ).run();
});
